module.exports = __webpack_public_path__ + "img/Noctiluca-Process-8.4c2d61c8.png";